// @flow
import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {useActions} from '../../../utils/globalStore';
import {actions as DashboardActions} from '../duck';
import {alterDateByDays, getFirstDayOfWeek} from '../../../utils/date';

import type {RootState} from '../..';

const completedConfigSelector = (state: RootState) =>
  state.dashboard.completedConfig;
const isFetchingCompletedConfigSelector = (state: RootState) =>
  state.dashboard.isFetchingCompletedConfig;

export function useCompletedConfig() {
  const completedConfig = useSelector(completedConfigSelector);
  const isFetching = useSelector(isFetchingCompletedConfigSelector);
  const fetchCompletedConfig = useActions(
    DashboardActions.fetchCompletedConfig
  );

  useEffect(() => {
    fetchCompletedConfig();
  }, [fetchCompletedConfig]);

  return {completedConfig, isFetching, fetchCompletedConfig};
}

export const getRangeDatesByPeriod = (period: string) => {
  let date;
  let end_date = alterDateByDays(1, new Date(), true);
  switch (period) {
    case 'today':
      return {
        init_date: new Date(),
        end_date,
      };
    case 'weekly':
      date = new Date();
      return {init_date: getFirstDayOfWeek(date), end_date};
    case 'monthly':
      date = new Date();
      let init_date = new Date(date.getFullYear(), date.getMonth(), 1);
      return {init_date, end_date};
    case 'threeMonths':
      return {init_date: alterDateByDays(90, new Date()), end_date};
    case 'sixMonths':
      return {
        init_date: alterDateByDays(180, new Date()),
        end_date,
      };
    case 'twelveMonths':
      return {
        init_date: alterDateByDays(360, new Date()),
        end_date,
      };

    default:
      return {init_date: new Date(), end_date};
  }
};

const WELCOME_MODAL_KEY = 'MODAL_WELCOME_SHOWN';
export function useShowWelcomeModal() {
  const handleClose = () => {
    localStorage.setItem(WELCOME_MODAL_KEY, 'true');
  };

  return {
    showModal: !localStorage.getItem(WELCOME_MODAL_KEY),
    handleClose,
  };
}
